import React from 'react';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from './RestrictToEnterpriseContainer';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { EvolutionChart } from '../../../../../entity/charts/evolution/EvolutionChart';
import { withUser } from '../../../../../user/UserContext';
import { UserContextType } from '../../../../../user/user.types';
import { DataSet } from '../../../../../entity/charts/getLineChartConfig';
import { EnterpriseData } from '../../../../../entity/entity.types';

type Props = {
  enterpriseDatas: EnterpriseData;
  source: string;
} & PropsFromRedux &
  WithRestrictedModalProps &
  UserContextType;

class RawEvolutionTab extends React.Component<Props> {
  filterSearch = (
    event: MouseEvent,
    _dataSet: DataSet & {
      customMetadatas?: { raisonSociale: string; enterpriseId: string };
    },
    year: string,
  ) => {
    const clickedSource = `${this.props.source}-evolution_chart`;
    if (this.props.accessPremium) {
      const data = {
        enterpriseId: this.props.enterpriseDatas.enterpriseId,
        raisonSociale: this.props.enterpriseDatas.raisonSociale,
        year,
        type: 'year' as const,
      };
      doctrineAnalytics('Search ChartSnippetClicked', data);
      this.props.onRestrictToEnterprise(data);
    } else {
      this.props.openRestrictedModal(clickedSource);
    }
  };

  render() {
    const { enterpriseDatas } = this.props;
    return (
      <button
        className="enterprise-snippet__evolution-panel enterprise-snippet__panel"
        type="button"
      >
        <EvolutionChart
          enterpriseDatas={enterpriseDatas}
          handleClick={this.filterSearch}
          oppositesEnterpriseDatas={[]}
        />
      </button>
    );
  }
}

export const EvolutionTab = Connect(
  withUser(withRestrictedModal(RawEvolutionTab)),
);
